import React, { useEffect, useState } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import DynamicContent from "./DynamicContent";
import Layout from "./Layout";
import NotFound from "./NotFound";
import Loading from "./Loading";
import { fetchData } from "./utils/statamic-api";

// Generic CMS-driven page. Fetches a `pages` collection entry by slug from
// Statamic and renders its Bard content via DynamicContent.
const Page = ({ slug }) => {
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPage = async () => {
      try {
        const data = await fetchData(
          `/collections/pages/entries?filter[slug:is]=${slug}&filter[site:is]=de`,
        );
        setPage(data.data.length > 0 ? data.data[0] : null);
      } catch (error) {
        console.error("Error fetching page:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchPage();
  }, [slug]);

  if (loading) return <Loading />;
  if (!page) return <NotFound />;

  return (
    <>
      <HelmetProvider>
        <Helmet>
          <title>{page.title} | Frontier Medical Group</title>
          {page.description && (
            <meta name="description" content={page.description} />
          )}
        </Helmet>
      </HelmetProvider>
      <Layout>
        <div className="max-w-4xl mx-auto px-4 sm:px-6 py-12">
          <h1 className="text-3xl font-bold tracking-tight text-fmg-dark-gray sm:text-5xl mb-8">
            {page.title}
          </h1>
          <DynamicContent content={page.content || []} align="left" />
        </div>
      </Layout>
    </>
  );
};

export default Page;
